module.exports = __webpack_public_path__ + "VIPV10.png?d9a44b529c615a1de2d9cf216c5ca1de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV10.png
// module id = 104
// module chunks = 0